import React, { useState } from "react";
import { PanelHorizontalContext } from '../Contexts';
export function PanelHorizontalProvider({ children }) {
    const [cuentaElementos, setCuentaElementos] = useState({});

    return (
        <PanelHorizontalContext.Provider
            value={{ cuentaElementos, setCuentaElementos }}
        >
            {children}
        </PanelHorizontalContext.Provider>
    );
}